import * as React from "react";

export default class SideNavButton extends React.Component<any, any> {
  componentDidMount() {
    $('.button-collapse').sideNav({
      closeOnClick: true,
      draggable: true // Choose whether you can drag to open on touch screens
    });
  }

  render() {
    return (
      <a href="#" data-activates="nav-mobile" className="button-collapse">
        <i className="material-icons">menu</i>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/my-app/side-nav-button.tsx